/**
 * @engine/vfx - Update Context Nodes
 *
 * Nodes for updating particles each frame.
 */

import type { VFXNodeDefinition } from '../../types';
import { dataPort, flowPort } from '../../types';

/**
 * Update context node definitions.
 */

export const OVER_LIFE_NODES: readonly VFXNodeDefinition[] = [
  // ---- Color Over Life ----
  {
    id: 'vfx.update.color_over_life',
    name: 'Color Over Life',
    category: 'attribute',
    contexts: ['update'],
    description: 'Animate color based on lifetime',
    color: '#FF9800',
    inputs: [
      flowPort('exec', ''),
      dataPort('gradient', 'Gradient', 'gradient', { defaultValue: null }),
    ],
    outputs: [
      flowPort('next', ''),
    ],
    modifiesParticle: true,
    shader: {
      code: `
        float t = particle.lifetime / particle.maxLifetime;
        particle.color = gradient(t);
      `,
    },
  },

  // ---- Alpha Over Life ----
  {
    id: 'vfx.update.alpha_over_life',
    name: 'Alpha Over Life',
    category: 'attribute',
    contexts: ['update'],
    description: 'Animate alpha based on lifetime',
    color: '#FF9800',
    inputs: [
      flowPort('exec', ''),
      dataPort('curve', 'Curve', 'curve', { defaultValue: null }),
    ],
    outputs: [
      flowPort('next', ''),
    ],
    modifiesParticle: true,
    shader: {
      code: `
        float t = particle.lifetime / particle.maxLifetime;
        particle.color.a = curve(t);
      `,
    },
  },

  // ---- Size Over Life ----
  {
    id: 'vfx.update.size_over_life',
    name: 'Size Over Life',
    category: 'attribute',
    contexts: ['update'],
    description: 'Animate size based on lifetime',
    color: '#FF9800',
    inputs: [
      flowPort('exec', ''),
      dataPort('curve', 'Curve', 'curve', { defaultValue: null }),
      dataPort('scale', 'Scale', 'float', { defaultValue: 1, range: { min: 0, max: 10 } }),
    ],
    outputs: [
      flowPort('next', ''),
    ],
    modifiesParticle: true,
    shader: {
      code: `
        float t = particle.lifetime / particle.maxLifetime;
        particle.size = curve(t) * scale;
      `,
    },
  },
];
